import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdatePackageUnitForm from "../../forms/CreateOrUpdatePackageUnitForm";
import { PackageUnitResponseDto } from "../../shared/dtos/packageUnit/PackageUnitResponseDto";

interface UpdatePackageUnitModalProps {
  open: boolean;
  onClose: () => void;
  unit: PackageUnitResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdatePackageUnitModal: React.FC<UpdatePackageUnitModalProps> = ({
  open,
  onClose,
  unit,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit Package: ${unit.name}`}
    width="sm"
    loading={loading}
  >
    <CreateOrUpdatePackageUnitForm
      isEditing={true}
      unit={unit}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdatePackageUnitModal;
